import { Link } from "react-router-dom";

interface ComicCardProps {
  id: number;
  title: string;
  cover: string;
  author: string;
  status: string;
  rating: number;
  views: number;
  category: string;
  tags: string[];
  updateDate: string;
}

export default function ComicCard({
  id,
  title,
  cover,
  author,
  status,
  rating,
  views,
  category,
  tags,
  updateDate,
}: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/comic/${id}`}
      className="group block"
      data-product-shop
    >
      {/* Cover */}
      <div className="relative overflow-hidden rounded-xl aspect-[3/4] mb-3">
        <img
          src={cover}
          alt={`${title} - 韩国漫画`}
          title={`${title} - 韩国漫画免费在线阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <div className="flex flex-wrap gap-1">
            {tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="text-[10px] px-2 py-0.5 rounded-full bg-background-50/20 text-background-50 backdrop-blur-sm"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
        {/* Status badge */}
        <span
          className={`absolute top-2 left-2 text-[10px] px-2 py-0.5 rounded-full font-medium ${
            status === "连载中"
              ? "bg-primary-500 text-background-50"
              : "bg-background-700/70 text-background-100 backdrop-blur-sm"
          }`}
        >
          {status}
        </span>
        {/* Rating */}
        <span className="absolute top-2 right-2 text-[10px] px-1.5 py-0.5 rounded-full bg-background-950/70 text-accent-400 backdrop-blur-sm font-semibold flex items-center gap-0.5">
          <i className="ri-star-fill text-[8px]"></i>
          {rating}
        </span>
      </div>

      {/* Info */}
      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate font-heading">
        {title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1 truncate">{author}</p>
      <div className="flex items-center gap-3 mt-1.5 text-[11px] text-foreground-400">
        <span className="flex items-center gap-1">
          <i className="ri-eye-line"></i>
          {formatViews(views)}
        </span>
        <span>{updateDate}</span>
      </div>
    </Link>
  );
}